<template>
  <v-btn
    v-if="showPrintButton && !mobileMenuMode"
    icon
    class="d-none d-sm-flex"
    @click="handleClickPrint"
  >
    <v-icon 
      :icon="mdiPrinter"
      color="base-white"
    />

    <v-tooltip
      activator="parent"
      location="bottom"
    >
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </v-btn>

  <v-list-item
    v-else-if="showPrintButton && mobileMenuMode"
    role="button"
    @click="handleClickPrint"
  >
    <template #prepend>
      <v-icon :icon="mdiPrinter" />
    </template>
    <v-list-item-title>{{ tooltip }}</v-list-item-title>
  </v-list-item>
</template>


<script>
import { mdiPrinter } from '@mdi/js'

export default {
    name: 'CrvAppPrint',

    props: {
      showPrintButton: {
        type: Boolean,
        default: false,
      },

      tooltip: {
        type: String,
        // default: `${print}`, //TODO: Implement i18n later
        default: 'Print',
      },

      mobileMenuMode: {
        type: Boolean,
        default: false,
        note: `Shows a list-item instead of a button when in mobile menu mode`,
      },
    },

    emits: [
        'click-print'
    ],

    data() {
        return {
          mdiPrinter
        }
    },

    methods: {
      handleClickPrint() {
          this.$emit('click-print')
        },
    },
}
</script>